import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=3bcedf50&scoped=true"
import script from "./Batches.vue?vue&type=script&lang=js"
export * from "./Batches.vue?vue&type=script&lang=js"
import style0 from "./Batches.vue?vue&type=style&index=0&id=3bcedf50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcedf50",
  null
  
)

export default component.exports